import HeadBanner from "../components/HeadBanner";
import bannerImg from "../assets/images/About-banner.png"
import LearnMore from "../components/LearnMore";
import CoreVision from "../components/CoreVision";
import WhoWeAre from "../components/WhoWeAre";
import HorizontalBar from "../components/HorizontalBar";

const AboutUs = () => {
    return(
        <>
            <HeadBanner imageUrl={bannerImg} />
            <LearnMore />
            {window.innerWidth <= 768 && <HorizontalBar />}
            <CoreVision />
            {window.innerWidth <= 768 && <HorizontalBar />}
            <WhoWeAre />
            {window.innerWidth <= 768 && <HorizontalBar />}
        </>
    )
}

export default AboutUs;